import React from 'react';
import { painPoints } from '../data/content';
export function WhySection() {
  return <section className="bg-navy-soft px-3 py-4 sm:px-6" data-id="element-174" data-mp="13v04hm1412si">
      <div className="mx-auto max-w-2xl" data-id="element-175" data-mp="13vjduecp2iux">
        <h2 className="text-center font-display text-[1.45rem] font-extrabold uppercase leading-none text-white sm:text-[2rem]" data-id="element-176" data-mp="18tuogratcxe7">
          DOES THIS SOUND <span className="text-signal" data-id="element-177" data-mp="1dmnvxmxo2jtz">FAMILIAR?</span>
        </h2>
        <p className="mt-1.5 text-center text-[0.8rem] leading-[1.4] text-white/80 sm:text-[0.95rem]" data-id="element-178" data-mp="1ikxnlnk6n2au">
          You arrive at a fiber optic network failure—but signal loss, defective splices, connector damage, fiber
          bends, reflections, and distribution problems can produce similar symptoms, making it difficult to isolate
          the actual fault.
        </p>
        <div className="mt-2 space-y-1.5" data-id="element-179" data-mp="3tch0xk2zrjz7">
          {painPoints.map(p => <div key={p.title} className="rounded-r-md border-l-4 border-signal bg-navy py-2 pl-2.5 pr-2" data-id="element-180" data-mp="3tek3f3lbz5kt">
              <h3 className="font-display text-[0.74rem] font-extrabold uppercase leading-tight text-white sm:text-[0.92rem]" data-id="element-181" data-mp="2ifmzvszmrqr4">
                {p.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] text-white/75 sm:text-[0.9rem]" data-id="element-182" data-mp="2dnltuot22w9j">{p.body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}